import RevokeUserPinModal from './RevokeUserPinModal';

export default RevokeUserPinModal;
